<div class="wrapper">
  <!-- top navbar-->
  <app-header
    class="topnavbar-wrapper"
    (toggle)="toggleSideBar()"
    (collapse)="collapseSideBar()"
  ></app-header>

  <!-- sidebar-->
  <app-sidebar
    class="aside-container"
    *ngIf="showSideBar"
    [isCollapsed]="sideBarIsCollapsed"
  ></app-sidebar>

  <!-- Main section-->
  <section class="section-container" [ngStyle]="!showSideBar && { 'margin-left': '0px' }">
    <!-- <app-breadcrumbs></app-breadcrumbs> -->
    <!-- Page content-->
    <div class="content-wrapper">
      <router-outlet></router-outlet>
    </div>
  </section>

  <footer class="footer-container">
    <span>© innovis sa {{ version }}</span>
  </footer>
</div>
